angular
	.module 'App.Module.PurchaseOrder', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'purchase_order',
					url: '/purchase_orders',
					views:
						main:
							templateUrl: '@app/layout/views/app.entity-administration.view.html'
							controller: 'MainCrudController'
							controllerAs: 'mainCrud'

						'entity_search@purchase_order':
							templateUrl: '@app/layout/views/app.entity-search.view.html'
							controller: 'PurchaseOrderSearchController'
							controllerAs: 'search'
					data:
						restrict: 'Backoffice.TopMenu.Stock'
						searchParams:
							redirectOnEmpty: true
							advanced:
								configuration: SEARCH_CONFIGURATION.purchase_order
							repositoryName: 'PurchaseOrderRepository'
							title: 'general.purchase_orders'
							newButtonSRef: 'reports.purchase_orders'
							labelTemplate: '@app/purchase-order/purchase-order.search-result-label.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						suppliers: (SuppliersRepository) ->
							return SuppliersRepository.getEntities()
						stockLocations: (StockLocationRepository) ->
							return StockLocationRepository.getEntities()
						shops: (ShopRepository) ->
							return ShopRepository.getEntities()
						priceRegions: (PriceRegionRepository) ->
							return PriceRegionRepository.getEntities()

			.state 'purchase_order.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						purchaseOrder: (PurchaseOrderRepository, $stateParams) ->
							return PurchaseOrderRepository.getEntity $stateParams.id

			.state 'purchase_order.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'PurchaseOrderController'
							controllerAs: 'vm'
							templateUrl: '@app/purchase-order/purchase-order.view.html'
